(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1bad"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1bad"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7dY2", function(module, exports) {
jQuery(document).ready(function($) {
    function headerScrollHandler() {
        let header = $("#site-header");
        const windowWidth = $(window).width();
        if (windowWidth > 991) {
            if ($(".header-wrapper").length === 0) $(".header-wrapp").wrapAll("<div class='header-wrapper' />");
            header = $(".header-wrapper");
        } else if ($(".header-wrapper").length !== 0) $(".header-wrapper").children().unwrap();
        if (window.scrollY > 0) header.addClass("site-header--sticky");
        else header.removeClass("site-header--sticky");
    }
    headerScrollHandler();
    $(document).on("scroll", headerScrollHandler);
    // Top banner reveal on scroll-up, hide on scroll-down.
    let lastScrollY = window.scrollY;
    function topBannerScrollHandler() {
        const topBanner = $(".onereach-topbanner");
        if (topBanner.length === 0) return;
        const currentScrollY = window.scrollY;
        const bannerHeight = topBanner.outerHeight();
        const stickyHeader = $(".header-wrapper").length !== 0 ? $(".header-wrapper") : $("#site-header");
        // Disable the reveal-on-scroll effect on small mobile screens.
        if ($(window).width() <= 576) {
            topBanner.removeClass("onereach-topbanner--hidden");
            stickyHeader.css("top", "");
            lastScrollY = currentScrollY;
            return;
        }
        // Banner is visible near the top of the page or when scrolling up,
        // and hidden while scrolling down.
        let showBanner;
        if (currentScrollY <= bannerHeight) showBanner = true;
        else if (currentScrollY > lastScrollY) showBanner = false;
        else showBanner = true;
        if (showBanner) {
            // Reveal the banner and push the header below it so they never overlap.
            topBanner.removeClass("onereach-topbanner--hidden");
            stickyHeader.css("top", bannerHeight + "px");
        } else {
            // Hide the banner and let the header stick to the very top on its own.
            topBanner.addClass("onereach-topbanner--hidden");
            stickyHeader.css("top", "");
        }
        lastScrollY = currentScrollY;
    }
    topBannerScrollHandler();
    $(document).on("scroll", topBannerScrollHandler);
    // Double nav
    const doubleNav = $(".site-header .header-second-nav");
    if (doubleNav.length !== 0) {
        $(".site-header .header-second-nav li:first-child").append(`<span class="icon"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="#E5E5E5" stroke-linecap="square"/></svg></span>`);
        $(".site-header .header-second-nav li:not(:first-child)").wrapAll('<div class="header-second-nav__wrapper"></div>');
        $(".site-header .header-second-nav ul > li:first-child").on("click", function(e) {
            e.preventDefault();
            $(this).toggleClass("active");
            $(this).closest(".site-header").find(".header-second-nav__wrapper").toggleClass("active");
            return false;
        });
    }
    $('.or-megamenu .menu-item-mega > a[href="#"]').on("click", function() {
        const parentItem = $(this).parent(".menu-item-mega");
        $(".menu-item-mega").not(parentItem).removeClass("active");
        parentItem.toggleClass("active");
        return false;
    });
    $("body").on("click", function(e) {
        if (!$(e.target).closest(".or-megamenu").length) $(".menu-item-mega").removeClass("active");
    });
    function adjustMegaMenuPosition() {
        $(".or-megamenu__columns-1, .small-width").each(function() {
            const leftPos = $(this).position().left;
            const menuWrapper = $(this).find(".or-megamenu__wrapper");
            menuWrapper.css("left", `${leftPos}px`);
        });
        $(".or-megamenu__wrapper").each(function() {
            const windowHeight = $(window).height();
            const siteHeaderHeight = $("#site-header").outerHeight();
            const availableHeight = windowHeight - siteHeaderHeight - 50;
            $(this).css("max-height", `${availableHeight}px`);
        });
    }
    adjustMegaMenuPosition();
    $(window).on("resize", adjustMegaMenuPosition);
});

});

parcelRegister("8hL8Y", function(module, exports) {
jQuery(document).ready(function($) {
    function mobFooterNav() {
        if ($(window).width() < 769) {
            $(".footer .footer__nav .menu-item-has-children > a").unbind("click");
            $(".footer .footer__nav .menu-item-has-children > a").click(function(e) {
                $(this).closest("li").find(".sub-menu").toggleClass("active");
                $(this).toggleClass("active");
                return false;
            });
        } else {
            $(".footer .footer__nav .menu-item-has-children > a").unbind("click");
            $(".footer .footer__nav .menu-item-has-children > a").click(function(e) {
                if ($(this).attr("href") !== "#") window.location.href = $(this).attr("href");
                return false;
            });
        }
    }
    mobFooterNav();
    $(window).resize(function() {
        mobFooterNav();
    });
    $(".footer .footer__nav .menu-item-has-children > a").each(function() {
        if ($(this).attr("href") !== "#") $(this).next(".sub-menu").prepend('<li class="menu-item menu-item-mob"><a href="' + $(this).attr("href") + '">' + $(this).text() + "</a></li>");
    });
    // Analytics
    $(".onereach-analytics-report__label").click(function() {
        $(".onereach-analytics-report").toggleClass("active");
    });
});

});

parcelRegister("k30zb", function(module, exports) {
jQuery(document).ready(function($) {
    const chat = $(".onereach-chat");
    if (chat.length) {
        $("html").addClass("with-chat");
        let chatOpenOnce = false;
        const chatIframe = chat.find("iframe");
        const closeIcon = chat.find(".onereach-chat__close");
        const chatLink = $('a[href="#onereach-chat"]');
        chatLink.on("click", function(e) {
            e.preventDefault();
            $("html").addClass("chat-active");
            if (!chatOpenOnce) {
                chatOpenOnce = true;
                chatIframe.attr("src", chatIframe.attr("src"));
            }
        });
        closeIcon.on("click", function(e) {
            e.preventDefault();
            $("html").toggleClass("chat-active");
            if (!chatOpenOnce) {
                chatOpenOnce = true;
                chatIframe.attr("src", chatIframe.attr("src"));
            }
        });
        const postToChat = $(".onereach-chat-post");
        const iframeWindow = chatIframe[0].contentWindow;
        postToChat.on("click", function(e) {
            e.preventDefault();
            $("html").addClass("chat-active");
            if (!chatOpenOnce) {
                chatOpenOnce = true;
                chatIframe.attr("src", chatIframe.attr("src"));
            }
            const demoId = $(this).attr("demo-id");
            iframeWindow.postMessage({
                type: "RUN_GLOBAL_COMMAND",
                payload: {
                    name: demoId
                }
            }, "*");
        });
    }
});

});

parcelRegister("5xgnb", function(module, exports) {
jQuery(document).ready(($)=>{
    function addUtmParams() {
        const pageUrl = new URL(window.location.href);
        const params = [
            "utm_source",
            "utm_medium",
            "utm_id",
            "utm_campaign",
            "utm_content"
        ];
        let utmParams = {};
        for(let i = 0; i < params.length; i++){
            const param = params[i];
            const value = pageUrl.searchParams.get(param);
            if (value === null) continue;
            utmParams[param] = value;
        }
        const utmLinks = $(".onereach-utm-link");
        if (Object.keys(utmParams).length === 0 || utmLinks.length === 0) return;
        utmLinks.each(function() {
            let element = $(this);
            const anchor = element.find("a");
            if (anchor.length > 0) element = anchor;
            const href = element.attr("href");
            if (!href) return;
            // In-page anchors, and schemes like mailto:/tel:/javascript:, must not get params
            if (href.startsWith("#") || /^(?!https?:)[a-z][a-z0-9+.-]*:/i.test(href)) return;
            // A base is required so relative hrefs ('/contact/') parse instead of throwing
            let url;
            try {
                url = new URL(href, window.location.href);
            } catch (e) {
                return;
            }
            for(let param in utmParams)if (utmParams[param]) url.searchParams.set(param, utmParams[param]);
            // Keep the href in the shape it was authored in, so the host is not baked in
            const isAbsolute = /^[a-z][a-z0-9+.-]*:\/\//i.test(href);
            element.attr("href", isAbsolute ? url.toString() : url.pathname + url.search + url.hash);
        });
    }
    addUtmParams();
});

});

// Header + footer only. Used by standalone templates (template-or-blocks.php)
// that drop the full front-end bundle.
parcelRequire("g7dY2");
parcelRequire("8hL8Y");
parcelRequire("k30zb");
parcelRequire("5xgnb");

})();
//# sourceMappingURL=header-footer.js.map
